import { BigNumber } from 'ethers';
import { formatEther, formatUnits, parseEther } from 'ethers/lib/utils';
import { config } from '../../config/config';
import { ExtendPositionParamsStruct } from '../../config/contracts/typechain/ITradeManager';

const generateSizePositionLog = (
    margin: string,
    volume: string,
    userFee: BigNumber,
    decimals: number,
    params: ExtendPositionParamsStruct
) => {
    const addedLeverage = BigNumber.from(params.addedLeverage)
        .div(config.leverageMultiplier)
        .toString();

    const addedMargin = formatUnits(params.addedMargin.toString(), decimals);

    const addedCollateral = parseEther(addedMargin)
        .mul(parseEther('1'))
        .div(parseEther('1').add(parseEther(addedLeverage).mul(userFee).div(100_00)));

    const addedSize = addedCollateral.mul(parseEther(addedLeverage)).div(parseEther('1'));

    const newVolume = formatEther(parseEther(volume).add(addedSize));

    const newMargin = formatEther(parseEther(margin).add(addedCollateral));

    const newLeverage = formatEther(
        parseEther(newVolume).mul(parseEther('1')).div(parseEther(newMargin))
    );

    const fees = formatEther(addedSize.mul(userFee).div(100_00));

    return {
        newVolume,
        newMargin,
        newLeverage,
        fees,
    };
};

export default generateSizePositionLog;
